import { useCallback, useEffect, useMemo, useState } from "react";
import type { RioTrip, TpgTrip } from "@types";
import { getTpgTrips } from "@services";
import { tpgTripToRioTrip } from "@utils/rioTripOptions";

export const useTpgTrips = () => {
  const [tpgTrips, setTpgTrips] = useState<TpgTrip[]>([]);

  const fetchTpgTrips = useCallback(async () => {
    try {
      setTpgTrips(await getTpgTrips());
    } catch {
      setTpgTrips([]);
    }
  }, []);

  const addTpgTrip = useCallback((trip: TpgTrip) => {
    setTpgTrips((prev) => (prev.some((item) => item.description === trip.description) ? prev : [...prev, trip]));
  }, []);

  useEffect(() => {
    fetchTpgTrips();
  }, [fetchTpgTrips]);

  const tpgTripsAsRioTrips = useMemo<RioTrip[]>(
    () => tpgTrips.filter((trip) => !!trip?.description?.trim()).map(tpgTripToRioTrip),
    [tpgTrips]
  );

  return { tpgTrips: tpgTripsAsRioTrips, fetchTpgTrips, addTpgTrip };
};
